import { intersection } from "lib/actions/util";
import { isSetSubsetOfArray } from "lib/actions/util/isSetSubsetOfArray";
import { getFileExtensions } from "./utils";

export const fbxExtensions = {
  required: new Set(["fbx", "pos"]),
  optional: new Set(),
};

const fbxExtensionsAll = [...fbxExtensions.required, ...fbxExtensions.optional];

export const isFbx = (filenames: string[]) => {
  const exts = getFileExtensions(filenames);
  return intersection(exts, fbxExtensionsAll).length > 0;
};

export const isCompleteFbx = (filenames: string[]) =>
  isSetSubsetOfArray(fbxExtensions.required, getFileExtensions(filenames));

export const isUnsupportedFbx = (filenames: string[]) => {
  const exts = getFileExtensions(filenames);
  return intersection(exts, fbxExtensionsAll).length !== exts.length;
};
